<template>
  <div class="content has_breadcrumb journal-inner">
    <base-breadcrumb :data="breadcrumbData" slot="breadcrumb" />
    <GgPage pageType="2" title="Journal">
      <div slot="topAppBar">
        <search />
      </div>
      <template v-slot:left>
        <div class="mar-l-b pdf-newsletter-create" v-if="hasPermission('Manage journals_Create')">
          <div class="pdf-create-button" @click.stop="toggleCreateMenu">
            <svg width="36" height="36" viewBox="0 0 36 36">
              <path fill="#34A853" d="M16 16v14h4V20z" />
              <path fill="#4285F4" d="M30 16H20l-4 4h14z" />
              <path fill="#FBBC05" d="M6 16v4h10l4-4z" />
              <path fill="#EA4335" d="M20 16V6h-4v14z" />
              <path fill="none" d="M0 0h36v36H0z" />
            </svg>
            <span>Start from scratch</span>
          </div>
          <div v-if="createDropdownSw" class="pdf-create-dropdown-ui">
            <div class="pdf-create-dropdown-list">
              <ul class="pdf-create-list">
                <li @click="toJournalCreate">Create new</li>
                <li @click="openPdfUpload">Upload PDF</li>
              </ul>
            </div>
            <div class="pdf-create-dropdown-bg" @click="createDropdownSw = false"></div>
          </div>
          <input
            ref="pdfInput"
            class="pdf-upload-input"
            type="file"
            accept="application/pdf,.pdf"
            @change="handlePdfSelected"
          />
        </div>
        <gg-flex-menus
          :menus="menuDatas"
          :canSelecteParent="true"
          @select="menuSelect"
          :default-active="menuActive"
        />
      </template>
      <div class="journal-list-inner">
        <div class="journal-classname">Select a template</div>
        <div class="template-filter">
          <div class="filter-search">
            <input type="text" placeholder="Search templates" v-model="search" />
            <div class="filter-search-icon">
              <i class="iconfont iconall_view_search" v-if="!search"></i>
              <i class="iconfont iconClose_24px" v-else @click="search = ''"></i>
            </div>
          </div>
        </div>
        <div class="main-inner" v-loading="loading">
          <div
            class="img-scroll"
            v-infinite-scroll="loadTemplates"
            v-loading="loading"
            ref="imgScroll"
            v-if="templateList.length > 0"
          >
            <div class="template-list">
              <TemplateItem
                v-for="item in templateList"
                :key="item.id"
                :item="item"
                :cantcheck="true"
                :onlyPreview="true"
                @handleAction="handleAction"
                @handleClickTemplate="handleClickTemplate"
              ></TemplateItem>
            </div>
          </div>
          <div class="empty-box" slot="empty" v-else>
            <img :src="require('@/assets/images/moments/empty_photo.png')" />
            <p>No template yet.</p>
          </div>
        </div>
      </div>
      <gg-Dialog
        width="580px"
        :visible.sync="pdfTitleDialogSw"
        title="Upload PDF"
        class="upload-pdf-title-dialog"
        :before-close="closePdfTitleDialog"
      >
        <div class="pdf-title-form">
          <div class="pdf-title-field" :class="{ error: pdfTitleError }">
            <label>Newsletter title *</label>
            <input
              ref="pdfTitleInput"
              v-model.trim="pdfTitle"
              maxlength="80"
              autocomplete="off"
              @keyup.enter="submitPdfUpload"
            />
          </div>
          <div class="pdf-title-meta">
            <div class="pdf-title-error">{{ pdfTitleError }}</div>
            <div class="pdf-title-count">{{ pdfTitle.length }} / 40</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="closePdfTitleDialog">Cancel</gg-cancel-button>
          <gg-submit-button :disabled="pdfUploadDisabled" @click="submitPdfUpload">
            Upload
          </gg-submit-button>
        </span>
      </gg-Dialog>
      <Snackbar :visible.sync="snackbarData.visible" :content="snackbarData.content" />
      <div class="pdf-upload-progress" v-if="pdfUploading">
        <div class="wd">Uploading PDF ...</div>
        <baseButton @click="stopPdfUpload" type="primary">Stop</baseButton>
        <div class="progress-bar">
          <span class="ratio" :style="'width:' + pdfProgress.ratio + '%'"></span>
        </div>
      </div>
    </GgPage>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { Ajax } from '@/common'
import { saveDraft } from '@/common/nav-state'
import { mapState } from 'vuex'
import search from './../modules/search'
import { hasPermission } from './../utils/utils.js'
import TemplateItem from '@/views/newsletterTemplates/components/TemplateItem.vue'

const PDFJS = require('pdfjs-dist')
PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry')

const DEFAULT_PAGE_SIZE = 36
const FOLDER_PAGE_SIZE = 9999
const POSTED_STATUS = 'POSTED'
const FILE_TYPE_TEMPLATE = 0
const FILE_TYPE_FOLDER = 1
const NEWSLETTER_TYPE = 0
const MENU_KEY_NEWSLETTER_TEMPLATES = 'NewsletterTemplates'

export default {
  name: 'JournalTemplateSelect',
  components: { TemplateItem, search },
  data() {
    return {
      activeParentId: '',
      menuActive: MENU_KEY_NEWSLETTER_TEMPLATES,
      journalListType: 'newsletter',
      search: '',
      pages: 0,
      pageNum: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      totalNum: 0,
      journalType: NEWSLETTER_TYPE,
      classid: '',
      loading: false,
      classname: '',
      isNewsletter: true,
      status: '',
      folderList: [],
      templateList: [],
      createDropdownSw: false,
      selectedPdfFile: null,
      pdfTitleDialogSw: false,
      pdfTitle: '',
      pdfTitleApiError: '',
      pdfUploading: false,
      pdfStopRequested: false,
      pdfUploadCancelSource: null,
      pdfProgress: {
        total: 0,
        cur: 0,
        ratio: 0
      },
      snackbarData: {
        visible: false,
        content: ''
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    }),
    breadcrumbData() {
      return [
        {
          routeName: 'locations',
          name: this.user.schoolName
        },
        {
          routeName: 'journal',
          name: 'Journal'
        },
        {
          routeName: 'journalClass',
          name: this.classname,
          params: {
            id: this.classid
          },
          query: {
            time: moment().valueOf(),
            // R32 标签 + year（C1）：回 class 页标签不再降级
            className: this.classname,
            classId: this.classid,
            year: this.$route.query.year || ''
          }
        },
        {
          name: 'Create new newsletter'
        }
      ]
    },
    menuDatas() {
      const datas = [
        {
          name: 'Newsletter templates',
          key: MENU_KEY_NEWSLETTER_TEMPLATES,
          active: true,
          children: []
        }
      ]
      this.folderList.forEach((item) => {
        const menuItem = {
          key: item.id,
          name: item.fileName,
          active: item.active || false,
          extra: item.includePublishedItems
        }
        datas[0].children.push(menuItem)
      })
      return datas
    },
    pdfTitleError() {
      if (this.pdfTitle.length > 40) {
        return 'Character limit of 40'
      }
      return this.pdfTitleApiError
    },
    pdfUploadDisabled() {
      return (
        this.pdfUploading ||
        !this.pdfTitle ||
        this.pdfTitle.length > 40 ||
        Boolean(this.pdfTitleApiError)
      )
    }
  },
  watch: {
    search() {
      this.initPageData()
    },
    pdfTitle() {
      this.pdfTitleApiError = ''
    }
  },
  created() {
    this.classname = this.$route.query.className || this.$route.query.classname || ''
    this.classid = this.$route.query.classId || this.$route.query.classid || ''
    this.type = +this.$route.query.type || NEWSLETTER_TYPE
    this.getFolderList()
    this.getData()
  },
  methods: {
    moment,
    hasPermission,

    initPageData() {
      this.loading = true
      this.pageNum = 1
      this.getData()
    },

    menuSelect(key) {
      this.menuActive = key
      this.activeParentId = key === MENU_KEY_NEWSLETTER_TEMPLATES ? '' : key
      this.initPageData()
    },

    getFolderList() {
      const params = {
        currentPage: 1,
        pageSize: FOLDER_PAGE_SIZE,
        newsletter: true,
        trash: false,
        staffId: this.user.userId,
        fileType: FILE_TYPE_FOLDER
      }
      Ajax.get('/journal/template/search/extra', params).then((res) => {
        this.loading = false
        if (res.code === '0000') {
          this.folderList = res.data.records
            .filter((item) => item.id !== this.folderId)
            .map((item) => ({
              ...item,
              active: false
            }))
        }
      })
    },

    loadTemplates() {
      if (this.pageNum < this.pages) {
        this.getData(true)
      }
    },

    getData(isLoadMore) {
      if (isLoadMore) {
        this.pageNum += 1
      }

      this.loading = true
      const params = {
        currentPage: this.pageNum,
        pageSize: this.pageSize,
        search: this.search,
        fileType: FILE_TYPE_TEMPLATE,
        status: POSTED_STATUS,
        newsletter: true,
        trash: false,
        staffId: this.user.userId
      }

      if (this.activeParentId) {
        params.parentId = this.activeParentId
      }

      Ajax.get('/journal/template/search/extra', params).then((res) => {
        this.loading = false
        if (params.search !== this.search) return

        if (res.code === '0000') {
          if (params.currentPage === 1) {
            this.templateList = res.data.records
          } else {
            this.templateList = [...this.templateList, ...res.data.records]
          }
          this.totalNum = res.data.count
          this.pages = Math.ceil(res.data.count / this.pageSize)
        }
      })
    },

    handleAction(key, item) {
      if (key === 'preview') {
        this.toPreview(item.id)
      }
    },

    handleClickTemplate(item) {
      this.$router.push({
        name: 'journalCreate',
        query: {
          type: this.type,
          classname: this.classname,
          classid: this.classid,
          // camelCase 双形态 + year（C1）：编辑器面包屑与保存回跳不再丢 year
          className: this.classname,
          classId: this.classid,
          year: this.$route.query.year || '',
          time: this.moment().valueOf(),
          templateId: item.id
        }
      })
    },

    toJournalCreate() {
      if (this.type === NEWSLETTER_TYPE) {
        this.createDropdownSw = false
        this.$router.push({
          name: 'journalCreate',
          query: {
            type: this.type,
            classname: this.classname,
            classid: this.classid,
            // camelCase 双形态 + year（C1）：同 handleClickTemplate
            className: this.classname,
            classId: this.classid,
            year: this.$route.query.year || '',
            time: this.moment().valueOf()
          }
        })
      }
    },

    toggleCreateMenu() {
      this.createDropdownSw = !this.createDropdownSw
    },

    openPdfUpload() {
      this.createDropdownSw = false
      if (this.$refs.pdfInput) {
        this.$refs.pdfInput.value = ''
        this.$refs.pdfInput.click()
      }
    },

    handlePdfSelected(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return

      const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '')

      if (!isPdf) {
        this.$message.error('Please upload a PDF file.')
        return
      }

      this.selectedPdfFile = file
      this.pdfTitle = ''
      this.pdfTitleApiError = ''
      this.pdfTitleDialogSw = true
      this.$nextTick(() => {
        if (this.$refs.pdfTitleInput) {
          this.$refs.pdfTitleInput.focus()
        }
      })
    },

    closePdfTitleDialog() {
      if (this.pdfUploading) return
      this.pdfTitleDialogSw = false
      this.selectedPdfFile = null
      this.pdfTitle = ''
      this.pdfTitleApiError = ''
    },

    stopPdfUpload() {
      this.pdfStopRequested = true
      if (this.pdfUploadCancelSource) {
        this.pdfUploadCancelSource.cancel('Upload stopped')
        this.pdfUploadCancelSource = null
      }
      this.finishPdfUpload(true)
    },

    finishPdfUpload(stopped) {
      this.pdfUploading = false
      if (!stopped) {
        this.pdfStopRequested = false
      }
      if (this.pdfUploadCancelSource) {
        this.pdfUploadCancelSource.cancel('Upload stopped')
        this.pdfUploadCancelSource = null
      }
      if (stopped) {
        this.selectedPdfFile = null
        this.showSnackbar('Upload stopped')
      }
      setTimeout(() => {
        if (!this.pdfUploading) {
          this.pdfProgress = {
            total: 0,
            cur: 0,
            ratio: 0
          }
        }
      }, 500)
    },

    createPdfUploadStoppedError() {
      const error = new Error('Upload stopped')
      error.code = 'UPLOAD_STOPPED'
      return error
    },

    isPdfUploadStoppedError(error) {
      return Boolean(
        error &&
        (error.code === 'UPLOAD_STOPPED' ||
          error.name === 'AbortError' ||
          (typeof axios.isCancel === 'function' && axios.isCancel(error)))
      )
    },

    ensurePdfUploadActive() {
      if (this.pdfStopRequested || !this.pdfUploading) {
        throw this.createPdfUploadStoppedError()
      }
    },

    async submitPdfUpload() {
      if (this.pdfUploadDisabled || !this.selectedPdfFile) return

      this.pdfTitleDialogSw = false
      this.pdfUploading = true
      this.pdfStopRequested = false
      this.pdfProgress = {
        total: 1,
        cur: 0,
        ratio: 0
      }

      try {
        const pageFiles = await this.convertPdfToImageFiles(this.selectedPdfFile)
        this.ensurePdfUploadActive()
        const uploadedPdf = await this.uploadNewsletterPdf(this.selectedPdfFile, pageFiles)
        this.ensurePdfUploadActive()
        await this.saveUploadedPdfNewsletter(uploadedPdf)
        this.finishPdfUpload(false)
        this.selectedPdfFile = null
        this.pdfTitle = ''
        this.showSnackbar('Newsletter has been saved as draft')
        this.toNewsletterDraft()
      } catch (error) {
        if (this.isPdfUploadStoppedError(error)) {
          return
        }
        this.finishPdfUpload(false)
        this.handlePdfUploadError(error)
      }
    },

    async convertPdfToImageFiles(pdfFile) {
      const buffer = await pdfFile.arrayBuffer()
      const pdf = await PDFJS.getDocument({ data: buffer }).promise
      const pageFiles = []
      this.pdfProgress = {
        total: pdf.numPages,
        cur: 0,
        ratio: 0
      }

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum += 1) {
        this.ensurePdfUploadActive()
        const page = await pdf.getPage(pageNum)
        const imageFile = await this.renderPdfPageToImageFile(page, pageNum, pdfFile.name)
        pageFiles.push(imageFile)
        this.pdfProgress.cur = pageNum
        this.pdfProgress.ratio = Math.round((pageNum / pdf.numPages) * 40)
      }

      return pageFiles
    },

    renderPdfPageToImageFile(page, pageNum, pdfName) {
      const viewport = page.getViewport({ scale: 1.2 })
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.width = viewport.width
      canvas.height = viewport.height

      return page
        .render({
          canvasContext: context,
          viewport
        })
        .promise.then(
          () =>
            new Promise((resolve, reject) => {
              canvas.toBlob(
                (blob) => {
                  if (!blob) {
                    reject(new Error('Failed to convert PDF page to image'))
                    return
                  }
                  const baseName = pdfName.replace(/\.pdf$/i, '')
                  resolve(
                    new File([blob], `${baseName}-page-${pageNum}.jpg`, {
                      type: 'image/jpeg',
                      lastModified: Date.now()
                    })
                  )
                },
                'image/jpeg',
                0.9
              )
            })
        )
    },

    async uploadNewsletterPdf(pdfFile, pageFiles) {
      this.ensurePdfUploadActive()
      const formData = new FormData()
      formData.append('title', this.pdfTitle)
      formData.append('file', pdfFile)
      pageFiles.forEach((file) => {
        formData.append('file', file)
      })

      const cancelSource = axios.CancelToken.source()
      this.pdfUploadCancelSource = cancelSource

      const res = await Ajax.post('/media/public/file/uploadNewsletterPdf', formData, {
        timeout: 10 * 60 * 1000,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        cancelToken: cancelSource.token,
        onUploadProgress: (progressEvent) => {
          if (!progressEvent.total) return
          const uploadRatio = progressEvent.loaded / progressEvent.total
          this.pdfProgress.cur = progressEvent.loaded
          this.pdfProgress.total = progressEvent.total
          this.pdfProgress.ratio = Math.min(
            100,
            40 + Math.round(Math.min(1, Math.max(0, uploadRatio)) * 60)
          )
        }
      })

      if (this.pdfUploadCancelSource === cancelSource) {
        this.pdfUploadCancelSource = null
      }

      if (res.code !== '0000') {
        const message = res.message || res.msg || res.info || ''
        if (/title/i.test(message) || /exist/i.test(message)) {
          this.pdfTitleApiError = 'Title already exists'
          this.pdfTitleDialogSw = true
        }
        throw new Error(message || 'Upload failed')
      }

      return res.data || {}
    },

    async saveUploadedPdfNewsletter(uploadedPdf) {
      const pdfPath = uploadedPdf.pdfPath || ''
      const imagePaths = uploadedPdf.imagePaths || []

      if (!pdfPath) {
        throw new Error('Upload failed: missing PDF path')
      }

      const res = await Ajax.post('/journal/addJournalV1', {
        classId: this.classid,
        isPdf: true,
        filePath: pdfPath,
        pdfImages: imagePaths,
        title: this.pdfTitle,
        staffId: this.user.userId,
        isNewsletter: true
      })

      if (res.code !== '0000') {
        throw new Error(res.message || res.msg || 'Save failed')
      }
    },

    handlePdfUploadError(error) {
      if (this.pdfTitleApiError) return
      const message = error && error.message ? error.message : 'Upload failed'
      this.showSnackbar(message)
    },

    showSnackbar(content) {
      this.snackbarData.content = content
      this.snackbarData.visible = true
    },

    toNewsletterDraft() {
      this.$router.push({
        name: 'journalClass',
        params: {
          id: this.classid
        },
        query: {
          typename: 'newsletter_draft',
          time: this.moment().valueOf()
        }
      })
    },

    toPreview(id) {
      Ajax.get('/journal/template/' + id, { id }).then((res) => {
        if (res.code === '0000') {
          // 模板预览不属于任何 journal 记录：draft token 交接且 journalId 置空
          //（语义等同原 removeItem，避免轮询/重试指向错误记录）
          const draftToken = saveDraft('journalEditor', {
            pageData: res.data.content,
            title: res.data.title,
            status: res.data.status,
            filePath: res.data.filePath,
            isPdf: 'false',
            pdfImages: '[]',
            journalId: '',
            pdfFailCount: '0',
            pdfGenerationToken: ''
          })
          const url = this.$router.resolve({
            path: '/journal/view?type=newsletter&draft=' + encodeURIComponent(draftToken)
          })
          const win = window.open(url.href, '_blank')
          win.onload = function () {
            setTimeout(function () {
              win.document.title = 'Preview'
            }, 100)
          }
        }
      })
    },

    toDetail(id, type, item) {
      this.$router.push({
        name: 'journalDraft',
        query: {
          id: id,
          name: item.title,
          type: type,
          classid: this.classid,
          className: this.classname,
          classId: this.classid,
          year: this.$route.query.year || ''
        }
      })
    },

    toEdit(id, type, item) {
      this.$router.push({
        name: 'journalCreate',
        query: {
          editid: id,
          type: type,
          classname: this.classname,
          classid: this.classid,
          time: this.moment().valueOf()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.ggPage {
  /deep/.base-list .title {
    font-family: 'opensans-semibold';
    color: #5f6368;
  }
}

/deep/ .ggPage-main-center .base-list {
  padding-bottom: 112px !important;
  .title {
    font-family: 'opensans-semibold';
    margin-left: 0;
    padding-left: 10px;
  }
  .main-column {
    font-family: 'opensans-semibold';
  }
  .main-column {
    .icon {
      border-radius: 50%;
    }
  }
  ul li {
    border-top: 0 none;
    border-bottom: 1px solid #e0e0e0;
    &:nth-child(2) {
      border-bottom: 1px solid #e0e0e0;
    }
  }
}

/deep/ .ggPage-main-left {
  height: 100%;
  .menus {
    height: calc(100% - 72px);
    overflow-y: auto;
  }
}

.mar-l-b {
  position: relative;
}

.pdf-upload-input {
  display: none;
}

.pdf-newsletter-create {
  .pdf-create-button {
    width: fit-content;
    height: 48px;
    box-sizing: border-box;
    border: 0;
    border-radius: 24px;
    background: #fff;
    box-shadow: 0px 3px 6px #00000029;
    padding-left: 16px;
    padding-right: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;

    svg {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
    }

    span {
      margin-left: 20px;
      color: #5f6368;
      font-size: 14px;
      font-family: OpenSans-Bold;
      white-space: nowrap;
    }

    &:hover {
      box-shadow: 0 3px 6px #0000004d;
      background-color: #f7f8f8;

      span {
        color: #202124;
      }
    }
  }
}

.pdf-create-dropdown-ui {
  position: absolute;
  left: 214px;
  top: 0;
  width: 152px;

  .pdf-create-dropdown-bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 101;
    overflow: hidden;
  }

  .pdf-create-dropdown-list {
    position: relative;
    z-index: 102;
    width: 152px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 3px 3px #0000004d;
    padding: 8px 0;
  }

  .pdf-create-list {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      line-height: 32px;
      padding-left: 15px;
      cursor: pointer;
      text-align: left;
      color: #202124;
      font-size: 14px;
      font-family: Roboto;

      &:hover {
        background-color: #eee;
      }
    }
  }
}

.journal-list-inner {
  height: 100%;
}

.journal-classname {
  padding: 0 10px 25px 10px;
  line-height: 80px;
  border-bottom: 1px solid #e0e0e0;
  color: #202124;
  font: normal normal 600 22px/30px Open Sans;
}

.template-filter {
  padding: 24px 0;
  padding-left: 12px;
  .filter-search {
    width: 254px;
    height: 40px;
    display: flex;
    align-items: center;
    position: relative;
    input {
      width: 254px;
      height: 40px;
      box-sizing: border-box;
      padding-left: 8px;
      border: 1px solid #cbd6e2;
      border-radius: 4px;
      padding-right: 36px;
      &:focus {
        outline: none;
        border-color: #2b7de9;
      }
    }
    &-icon {
      position: absolute;
      right: 8px;
    }
  }
}

.main-inner {
  position: relative;
  height: calc(100% - 144px);
  overflow-y: auto;
}

.upload-pdf-title-dialog {
  /deep/ .el-dialog__body {
    padding: 0;
  }

  .pdf-title-form {
    padding: 22px 20px 18px;
  }

  .pdf-title-field {
    border-bottom: 1px solid #1a73e8;
    padding-bottom: 6px;

    label {
      display: block;
      color: #1a73e8;
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 12px;
    }

    input {
      width: 100%;
      border: 0;
      outline: none;
      color: #202124;
      font-size: 16px;
      line-height: 24px;
      padding: 0;
      background: transparent;
    }

    &.error {
      border-bottom-color: #d93025;

      label {
        color: #d93025;
      }
    }
  }

  .pdf-title-meta {
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
    color: #202124;
    font-size: 12px;
    line-height: 18px;
  }

  .pdf-title-error {
    color: #d93025;
  }
}

.pdf-upload-progress {
  position: fixed;
  z-index: 999;
  bottom: 16px;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  width: 370px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  padding: 20px 16px 28px;
  overflow: hidden;

  .wd {
    line-height: 24px;
    height: 24px;
    color: #202124;
    font-size: 18px;
  }

  .progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 8px;
    background: #e0e0e0;

    .ratio {
      float: left;
      height: 100%;
      background: #1a73e8;
    }
  }

  .base-button {
    position: absolute;
    right: 16px;
    top: 16px;
  }
}
</style>
